(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staggered-image-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('[data-staggered-grid]');
    if (!sections.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    sections.forEach(initStaggeredGrid);

    function initStaggeredGrid(container) {
      const section = container.closest('.staggered-grid');
      const verticalIntensity = parseFloat(section.getAttribute('data-vertical-intensity')) || 20;
      const horizontalIntensity = parseFloat(section.getAttribute('data-horizontal-intensity')) || 0;
      const rows = container.querySelectorAll('[data-parallax-row]');
      if (!rows.length) return;

      const rowBaseTransforms = [];
      rows.forEach((row, index) => {
        const computed = window.getComputedStyle(row);
        const transform = computed.transform;
        rowBaseTransforms[index] = transform === 'none' ? '' : transform;
      });

      let isInView = false;
      let rafId = null;
      let lastProgress = null;

      const horizontalMultipliers = [0.6, -0.9, 0.4, -1.0];

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isInView = entry.isIntersecting;
            if (isInView) {
              scheduleUpdate();
            }
          });
        },
        { threshold: 0, rootMargin: '300px 0px' }
      );

      observer.observe(section);

      function scheduleUpdate() {
        if (rafId) return;
        rafId = requestAnimationFrame(update);
      }

      function update() {
        rafId = null;
        if (!isInView) return;

        const rect = section.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const sectionCenter = rect.top + rect.height / 2;
        const distanceFromViewportCenter = sectionCenter - viewportHeight / 2;
        const maxDistance = (viewportHeight + rect.height) / 2;
        const progress = Math.max(-1, Math.min(1, distanceFromViewportCenter / maxDistance));

        if (lastProgress !== null && Math.abs(progress - lastProgress) < 0.001) {
          scheduleUpdate();
          return;
        }
        lastProgress = progress;

        const translateY = progress * verticalIntensity * -1;

        rows.forEach((row, index) => {
          const horizontalMult = horizontalMultipliers[index] || 0;
          const driftX = progress * horizontalIntensity * horizontalMult;
          const base = rowBaseTransforms[index];
          const parallax = 'translate3d(' + driftX.toFixed(2) + 'px, ' + translateY.toFixed(2) + 'px, 0)';
          row.style.transform = base ? base + ' ' + parallax : parallax;
        });

        scheduleUpdate();
      }

      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });
      scheduleUpdate();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
